import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const SnelStartIntegrationForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    // Set the api object
    const apiObject = 'integration/snelstart';

    // Configure the job fields
    const fields: FieldType[] = [
        {
            type: 'header',
            header: "integrations.general.api_token_label",
            description: "integrations.general.snelstart.client_key_description"
        },
        {
            type: 'secret',
            name: 'client_key',
            placeholder: 'integrations.general.snelstart.client_key_placeholder',
        },
        {
            type: 'header',
            header: "integrations.general.functions_header"
        },
        {
            name: 'import_relations',
            label: 'integrations.general.import_relations_label',
            type: 'switch',
        },
        {
            name: 'import_products',
            label: 'integrations.general.import_products_label',
            type: 'switch',
        },
        {
            name: 'import_orders',
            label: 'integrations.general.snelstart.import_orders_label',
            type: 'switch',
        },
        {
            type: 'dropdown',
            name: 'import_orders_filter',
            label: 'integrations.general.snelstart.import_orders_filter_label',
            allowNoneOption: false,
            hardcodedOptions: [
                { value: 'Werkbon', name: 'integrations.general.snelstart.import_orders_filter_options.no_filter' },
                { value: 'Bevestiging', name: 'integrations.general.snelstart.import_orders_filter_options.confirmations_only' },
            ],
            dependentOn: { fieldName: 'import_orders', value: true }
        },
        {
            name: 'export_job_to_invoice',
            label: 'integrations.general.export_job_to_invoice_label',
            type: 'switch',
        },
        {
            type: 'header',
            header: "integrations.general.integration_settings_label",
            dependentOn: { fieldName: 'export_job_to_invoice', value: true }
        },
        {
            type: 'dropdown',
            name: 'export_orders_filter',
            label: 'integrations.general.snelstart.export_orders_filter_label',
            allowNoneOption: false,
            hardcodedOptions: [
                { value: 'Order', name: 'integrations.general.snelstart.export_orders_filter_options.order' },
                { value: 'Offerte', name: 'integrations.general.snelstart.export_orders_filter_options.offerte' },
                { value: 'Bevestiging', name: 'integrations.general.snelstart.export_orders_filter_options.bevestiging' },
                { value: 'Werkbon', name: 'integrations.general.snelstart.export_orders_filter_options.werkbon' },
                { value: 'Pakbon', name: 'integrations.general.snelstart.export_orders_filter_options.pakbon' },
                { value: 'Afhaalbon', name: 'integrations.general.snelstart.export_orders_filter_options.afhaalbon' },
            ],
            dependentOn: { fieldName: 'export_job_to_invoice', value: true }
        },
        {
            type: 'text',
            name: 'default_article_code',
            label: 'integrations.general.snelstart.default_article_code_label',
            placeholder: 'integrations.general.snelstart.default_article_code_placeholder',
            tooltipText: 'integrations.general.snelstart.default_article_code_tooltip',
            dependentOn: { fieldName: 'export_job_to_invoice', value: true }
        },
        {
            type: 'dropdown',
            name: 'import_material_prices_include_vat',
            label: 'integrations.general.snelstart.import_material_prices_include_vat_label',
            tooltipText: 'integrations.general.snelstart.import_material_prices_include_vat_tooltip',
            allowNoneOption: false,
            hardcodedOptions: [
                { value: '0.00', name: 'integrations.general.snelstart.import_material_prices_include_vat_options.excl' },
                { value: '0.09', name: 'integrations.general.snelstart.import_material_prices_include_vat_options.incl_9' },
                { value: '0.21', name: 'integrations.general.snelstart.import_material_prices_include_vat_options.incl_21' },
            ],
        },
        {
            type: 'header',
            showOnEdit: true,
        },
        {
            name: 'is_active',
            label: 'integrations.general.is_active_label',
            type: 'checkbox',
            showOnEdit: true,
            tooltipText: 'integrations.general.is_active_tooltipText',
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            primaryButtonLabel='integrations.general.connect_button_label'
        />
    );
};

export default SnelStartIntegrationForm;
